import { campaignTypes } from "@campaign/campaign-types.di";
import { CampaignDatasource } from "@campaign/data/datasources/campaign.datasource";
import { CampaignMapper } from "@campaign/data/mappers/campaign.mapper";
import { CropTypeMapper } from "@campaign/data/mappers/crop-type.mapper";
import { CampaignImplRepository } from "@campaign/data/repositories/campaign.impl-repository";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import { CampaignCreateUseCase } from "@campaign/domain/usecases/campaign-create.usecase";
import { CampaignDeleteUseCase } from "@campaign/domain/usecases/campaign-delete.usecase";
import { CampaignGetAllUseCase } from "@campaign/domain/usecases/campaign-get-all.usecase";
import { CampaignGetByIdUseCase } from "@campaign/domain/usecases/campaign-get-by-id.usecase";
import { CampaignUpdateUseCase } from "@campaign/domain/usecases/campaign-update.usecase";
import { CropTypeGetAllUseCase } from "@campaign/domain/usecases/crop-type-get-all.usecase";
import { CampaignFilterViewmodel } from "@campaign/presentation/components/campaign-filter/campaign-filter.viewmodel";
import { CampaignComponentViewmodel } from "@campaign/presentation/components/campaign/campaign.viewmodel";
import { CampaignCreateModalViewModel } from "@campaign/presentation/components/campaign/create/campaign-create-modal.viewmodel";
import { CampaignUpdateModalViewModel } from "@campaign/presentation/components/campaign/update/campaign-update-modal.viewmodel";
import { HistoricalCampaignComponentViewmodel } from "@campaign/presentation/components/historical-campaign/historical-campaign.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webCampaignModule = new DiModuleBuilder();

webCampaignModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(CampaignDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(CampaignMapper).toSelf();
        bind(CropTypeMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<CampaignRepository>(
            campaignTypes.repositories.CampaignRepository,
        ).to(CampaignImplRepository);
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(CampaignGetAllUseCase).toSelf();
        bind(CampaignGetByIdUseCase).toSelf();
        bind(CampaignCreateUseCase).toSelf();
        bind(CampaignUpdateUseCase).toSelf();
        bind(CropTypeGetAllUseCase).toSelf();
        bind(CampaignDeleteUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(CampaignComponentViewmodel).toSelf();
        bind(CampaignFilterViewmodel).toSelf();
        bind(HistoricalCampaignComponentViewmodel).toSelf();
        bind(CampaignCreateModalViewModel).toSelf();
        bind(CampaignUpdateModalViewModel).toSelf();
    }),
}));

webCampaignModule.registerModule();

export { webCampaignModule };
